import React from 'react';

import OrderStatusPills from './OrderStatusPills';
import { formatDate, useFormatUSD } from '../../../utils/formatting';

/**
 * Header for a placed order. Mirrors DraftOrderHeader's markup so the two
 * views share styling, but shows order-specific meta (order date, balance
 * outstanding) instead of quote expiration.
 */
function OrderHeader({ order, onClick = null }) {
  if (!order) return null;

  const outstanding = parseFloat(order.totalOutstanding);
  const hasOutstanding = Number.isFinite(outstanding) && outstanding > 0;
  const outStandingEqualsTotal = Number(outstanding) === Number(order.currentTotalPrice);

  

  return (
    <div className="draft-order-header">
      
      <div className="draft-order-title">
        <h2
          className="heading heading--h2"
          onClick={onClick}
          style={{ cursor: onClick ? 'pointer' : 'default' }}
        >
          {'Order ' + (order.name || '')}
          {order.draft && (
            <span className="quote-number"><span>&nbsp;-&nbsp;</span>(Quote {order.draft})</span>
          )}
        </h2>

        <OrderStatusPills order={order} />
      </div>

      <div className="draft-order-total">
        <div className="total-amount">
          Total:{' '}
          <strong className="total-amount-value">
            {useFormatUSD(order.currentTotalPrice)}
          </strong>
        </div>

        {hasOutstanding && !outStandingEqualsTotal && (
          <div className="total-outstanding">
            Balance Due:{' '}
            <strong className="total-amount-value">
              {useFormatUSD(order.totalOutstanding)}
            </strong>
          </div>
        )}

        <div className="draft-order-meta">
          {order.createdAt && (
            <div className="created-on">
              Order Created: <span className="date-value">{formatDate(order.createdAt)}</span>
            </div>
          )}
        </div>

        
      </div>
    </div>
  );
}

export default OrderHeader;
